import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmarCorreoService } from '../_services/confirmar-correo.service';
import { NotificationService } from '../_services/notification.service';

@Component({
  selector: 'app-confirmar-correo',
  templateUrl: './confirmar-correo.component.html',
  styleUrls: ['./confirmar-correo.component.css']
})
export class ConfirmarCorreoComponent implements OnInit{

  constructor(
    private _route: ActivatedRoute,
    private _confirmarCorreo: ConfirmarCorreoService,
    private _notificacionService: NotificationService
  ){}
  
  identificador: string = '';
  identificadorCorrecto: string = '';
  blockEnvioCorreo: boolean = false;

  ngOnInit(): void {
    this.obtenerIdentificador();
  }

  obtenerIdentificador() {
    this._route.params
      .subscribe(params => {
        this.identificador = params['identificador'];
        this._confirmarCorreo.checkIdentificador(this.identificador).subscribe({
          next: (data) => {
            this.identificadorCorrecto = 'valido';
          },
          error: (error) => {
            console.error(error);
            
            if(error.error.responseCode == '644'){
              this.identificadorCorrecto = 'caducado';
            }
            if(error.error.responseCode == '643'){
              this.identificadorCorrecto = 'incorrecto';
            }
          }
        })
      }
    );
  }

  reenviarCorreo(){
    this.blockEnvioCorreo = true;
    this._confirmarCorreo.reenviarCorreo(this.identificador).subscribe({
      next: (data) => {
        this._notificacionService.info('Atención', 'Se ha enviado el email de confirmación a su cuenta de correo');
        this.blockEnvioCorreo = false;
      },
      error: (error) => {
      }
    })
  }

}
